import { generateCss } from "@/lib/canvas/styles";
import { configStore, globalStore } from "@/store/store-accessor";
import {
  addOrUpdateGeneratedGlobalStylesInlineCSSInCanvasHead,
  addOrUpdateGeneratedSelectorsInlineCSSInCanvasHead
} from "@/lib/canvas/assets/css-in-head";
import { addJavaScriptsInSettingsToHead } from "@/lib/canvas/assets/js-in-head";
import { addOrUpdateGeneratedPresetsInlineCSSInCanvasHead } from "@/lib/canvas/assets/css-in-head/presets";

export function handleGlobalSettingsChanged(canvasDocument: Document) {
  const css = generateCss(
    globalStore.globalSettings,
    configStore.breakpoints,
    configStore.globalSettingsControlsAndTemplate.template,
    {},
    configStore.globalSettingsControlsAndTemplate
      .propertyPathsToWhitelistInFlatProps
  );

  addOrUpdateGeneratedGlobalStylesInlineCSSInCanvasHead(canvasDocument, css);

  /* this is so brittle... like, its not declarative enough - we have the data
  which describes the controls for the javascript inputs in our PHP...
  but then we have to KNOW about that shit over here to add the javascripts to the head */

  addJavaScriptsInSettingsToHead(canvasDocument, globalStore.globalSettings);

  /* end lame procedural javascript loserness */
}

export function handlePresetsChanged(canvasDocument: Document) {
  const css = globalStore.presets
    .map(preset => {
      const element = configStore.element(preset.availableForType);

      return generateCss(
        { design: preset.design },
        configStore.breakpoints,
        element.cssTemplate,
        {
          selector: `.breakdance .bde-preset-${preset.id}`
        },
        element.propertyPathsToWhitelistInFlatProps
      );
    })
    .join(" ");

  addOrUpdateGeneratedPresetsInlineCSSInCanvasHead(canvasDocument, css);
}

export function handleGlobalSelectorsChanged(canvasDocument: Document) {
  const selectorCss = globalStore.cssSelectors.reduce(
    (acc, cssSelector) =>
      acc +
      generateCss(
        cssSelector.properties,
        configStore.breakpoints,
        configStore.classTemplate,
        {
          selector:
            cssSelector.type === "class"
              ? `.breakdance ${cssSelector.name}`
              : cssSelector.name
        }
      ),
    ""
  );

  addOrUpdateGeneratedSelectorsInlineCSSInCanvasHead(
    canvasDocument,
    selectorCss
  );
}
